import cn from 'classnames';
import { useState } from 'react';
import { Button, Flex, Form, Icon, Input, RadioPills, Wrapper } from 'ui';
import type { ChatroomListType } from '../../types';

export type ChatroomSidebarFiltersFormValues = {
  search?: string;
  type?: ChatroomListType;
};

const typeOptions = [
  { label: 'All', value: 'all' } as const,
  { label: 'Unread', value: 'unread' } as const,
  { label: 'Groups', value: 'groups' } as const,
];

type P = {
  onCreateChatClicked: () => Promise<void>;
};

const ChatroomSidebarFilters = ({ onCreateChatClicked }: P) => {
  const [isSearchDisplayed, setIsSearchDisplayed] = useState(false);
  const form = Form.useFormInstance<ChatroomSidebarFiltersFormValues>();
  const search = Form.useWatch('search', form);
  const hasSearch = Boolean(search?.trim());

  return (
    <Wrapper paddingHorizontal="xs" paddingVertical="sm">
      {isSearchDisplayed ? (
        <Flex flex={1} gap="xxs">
          <Button
            aria-label="Hide search"
            icon={<Icon icon="left-line" />}
            onClick={() => {
              setIsSearchDisplayed(false);
              form.setFieldValue('search', '');
            }}
            type="text"
          />
          <Flex flex={1}>
            <Form.Item<ChatroomSidebarFiltersFormValues> name="search" noStyle>
              <Input
                allowClear
                // eslint-disable-next-line jsx-a11y/no-autofocus -- intentionally autofocus the input when search is displayed
                autoFocus
                placeholder="Search"
                prefix={<Icon icon="search-2-line" type="default" />}
              />
            </Form.Item>
          </Flex>
        </Flex>
      ) : (
        <Flex gap="xxs" justify="space-between">
          <Button
            aria-label="Show search"
            icon={<Icon icon="search-2-line" />}
            onClick={() => {
              setIsSearchDisplayed(true);
            }}
            type="text"
          />
          <Button
            aria-label="Create a message"
            icon={<Icon icon="add-line" />}
            onClick={onCreateChatClicked}
            type="text"
          />
        </Flex>
      )}
      <div
        className={cn('chatroom-sidebar-filters-type', {
          'chatroom-sidebar-filters-type--hidden': hasSearch,
        })}
      >
        <div className="chatroom-sidebar-filters-type__content">
          <Wrapper paddingHorizontal="xs" paddingVertical="xxs">
            <Form.Item<ChatroomSidebarFiltersFormValues> name="type" noStyle>
              <RadioPills<ChatroomListType> items={typeOptions} marginBottom={false} />
            </Form.Item>
          </Wrapper>
        </div>
      </div>
    </Wrapper>
  );
};

export default ChatroomSidebarFilters;
